import { render, staticRenderFns } from "./AssignService.vue?vue&type=template&id=13637965"
import script from "./AssignService.vue?vue&type=script&lang=ts"
export * from "./AssignService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports